import React, { useState } from "react";
import { images } from "../../constant";
import { AppWrapper, MotionWrapper } from "../../wrapper";
import { client } from "../../client";

import "./Footer.scss";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const Footer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const { name, email, message } = formData;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    setIsLoading(true);

    const contact = {
      _type: "contact",
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    client
      .create(contact)
      .then(() => {
        setIsLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));

    setTimeout(() => {
      setIsFormSubmitted(false);
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    }, 5000);
  };

  return (
    <>
      <h2>Take a Coffee & Chat With Me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:auvipujondas@gmail.com" className="p-text">
            auvipujondas@gmail.com
          </a>
        </div>

        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel:+88 01789-173903" className="p-text">
            +88 01789-173903
          </a>
        </div>
        <div className="app__footer-card ">
          <div className="app__footer-social">
            <div>
              <a
                href="https://github.com/the-pujon"
                target="_blank"
                rel="noreferrer"
              >
                <BsGithub />
              </a>
            </div>
            <div>
              <a
                href="https://www.facebook.com/pujon.pujon.7"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF />
              </a>
            </div>
            <div>
              <a
                href="https://www.linkedin.com/in/pujon-das-auvi-6b1337222/"
                target="_blank"
                rel="noreferrer"
              >
                <BsLinkedin />
              </a>
            </div>
          </div>
        </div>
      </div>

      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleInputChange}
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              name="message"
              placeholder="Your message"
              value={message}
              onChange={handleInputChange}
            />
          </div>
          <button type="submit" className="p-text" onClick={handleSubmit}>
            {!isLoading ? "Send Message" : "Sending..."}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
        </div>
      )}
    </>
  );
};

export default AppWrapper(
  MotionWrapper(Footer, "app__footer"),
  "contact",
  "app__primarybg"
);
